/* eslint-disable camelcase */
export default {
	// 商户号查询
	apply_no: 'Apply no',
	applicant: 'Applicant',
	department: 'Department',
	merchant_subject: 'Merchant subject',
	group_merchant_name: 'Funding System Name',
	status: 'Status',
	merchant_channel: 'Merchant channel',
	merchant_type: 'Merchant type',
	funds_scene: 'Funds scene',
	apply_date: 'Apply date',
	merchant_number: 'Merchant number',
	operation: 'Operation',
	draft_flag: 'Include draft',
	please_input_apply_no: 'please input apply no',
	please_input_merchant_no: 'please input merchant no.',
	please_search_applicant: 'please search and select applicant',
	please_search_dept: 'please search and select department',
	please_search_subject: 'please select or search subject',
	please_input_merchant_name: 'please input group merchant  name',
	please_select_status: 'please select status',
	please_select_merchant_channel: 'please select merchant channel',
	please_select_merchant_type: 'please select merchant type ',
	please_select_funds_scene: 'please select funds scene',
	please_select_biz_feature: 'please select business feature',
	please_select_merchant_full_name: 'please select group merchant name',
	please_select_biz_purpose: 'please input business purpose',
	please_select_biz_product_name: 'please input business/product name',
	please_select_biz_background: 'please input business background',
	please_select_funds_flow_desc: 'please input funds flow description',
	please_select_data_flow_desc: 'please input data flow description',
	please_select_trade_scale: 'please input trade scale',
	please_select_data_check: 'please input data check description',
	please_select_group_subject: 'please select group subject',
	please_select_province: 'please select province and city',
	please_select_industry: 'please select industry',
	please_select_super_admin_type: 'please input super admin type',
	please_input_super_admin_name: 'please input super admin name',
	please_input_super_admin_phone: 'please input super admin phone number',
	please_select_super_admin_cert_type: 'please select super admin certificate type',
	// validate start
	please_input_finance_auditors: 'please input merchant admin ',
	please_input_biz_auditors: 'please input business auditor',
	please_input_dept: 'please input department',
	please_input_bg: 'please input BG',
	please_upload_attachments: 'please upload attachments',
	please_upload_merchant_name: 'please input merchant name',

	// validate end
	submit: 'Submit',
	save_draft: 'Save as draft',
	back: 'back',
	apply_info: 'Apply Information',
	creator: 'Creator',
	biz_applyer: 'Business applicant',
	biz_checker: 'Business checker',
	super_admin: 'Merchant admin',
	biz_dept: 'Business department',
	biz_bg: 'Business BG',
	biz_feature: 'Business feature',
	merchant_full_name: 'Group merchant name',
	biz_purpose: 'Business purpose',
	biz_mail_audit_file: 'Business mail audit file',
	for_not_fit_biz_tip: 'For non-FiT business, please select under "Company Business"',
	merchant_full_name_tip_1: 'This field is not visible to users and is only named for internal management requirements.',
	merchant_full_name_tip_2: 'Format requirements: BG - Business Line - Product Name - Funding Scenario',
	merchant_full_name_tip_3:
		'Example: CSIG - xx business line - xx product - revenue scenario - self-operated revenue/payment scenario - marketing campaign payment',
	biz_product_name: 'Business/Product name',
	biz_background: 'Business background',
	funds_flow_desc: 'Funds flow',
	funds_flow_file: 'Funds flow file',
	data_flow_desc: 'Data flow',
	data_flow_file: 'Data flow file',
	trade_scale: 'Trade scale',
	data_check: 'Data check description',
	other_statement_file: 'Other documents',
	biz_info: 'Business Information',
	group_subject_info: 'Group Subject Information',
	group_subject: 'Group subject',
	subject_type: 'Subject type',
	Operating_info: 'Operating Information',
	merchant_short_name: 'Merchant short name',
	merchant_short_name_tip_1: '1. Show to the buyer on the payment completion page, which must be related to the WeChat business category.',
	merchant_short_name_tip_2: '2. Requirements:',
	merchant_short_name_tip_3:
		'① It is not supported to simply name the name of the person. If it is a self-employed business, it can be named by "self-employed + operator\'s name" or "operator\'s name + business", such as "self-employed Zhang San" or "Zhang San Restaurant";',
	merchant_short_name_tip_4: '② Do not support meaningless copy, such as "XX special merchant", "800", "XX customer service phone XXX";',
	service_phone: 'Service phone',
	service_phone_tip: 'The default phone number is the public customer service phone number of Tencent Group, which can be modified by yourself',
	sales_scenes: 'Sales scenes',
	sales_scenes_tip_1:
		'Please check the actual sale of goods/provided service scenarios (at least one) in order to activate the required payment authority for you',
	sales_scenes_tip_2: ' Fill in the Business Scenario Guidelines',
	sales_scenes_tip_3:
		'It is recommended to only check the currently necessary scenarios so as to pass the check-in review as soon as possible. You can apply for other payment permissions after you have settled in according to your actual needs.',
	sales_scenes_store: 'Store',
	sales_scenes_mp: 'Official Accounts',
	sales_scenes_mini_program: 'Applet',
	sales_scenes_app: 'App',
	sales_scenes_web: 'Internet site',
	sales_scenes_wework: 'Enterprise wechat',
	sales_scenes_store_name: 'Store name',
	sales_scenes_store_province: 'Store province and city',
	sales_scenes_store_address: 'Store address',
	sales_scenes_store_indoor_app_view: ' AppID Viewing Guidelines',
	sales_scenes_store_address_tip_1:
		'Please fill in the detailed business location information. If there are multiple locations, just select a main location and fill in',
	sales_scenes_store_entrance_pic: 'Store entrance picture',
	sales_scenes_store_entrance_pic_tip_1:
		'Please upload a photo of the store (requires the store sign to be clearly visible). If it is a parking lot, vending machine, etc. without a fixed photo of the door, please provide the real photo of the business site',
	sales_scenes_store_indoor_pic: 'Store indoor picture',
	sales_scenes_store_indoor_pic_tip_1:
		'Please upload a photo of the interior of the store. If it is a parking lot, vending machine, etc. without a fixed photo of the door, please provide the real photo of the business site',
	sales_scenes_store_app_id: 'Store appid',
	sales_scenes_store_indoor_app_tip_1:
		'1. You can fill in the APPID of the certified official account, applet, and application, of which the official account APPID must be a certified service account, government or media subscription account.',
	sales_scenes_store_indoor_app_tip_2: ' AppID Viewing Guidelines',
	sales_scenes_store_indoor_app_tip_3:
		'2. After completing the entry, the system initiates the binding of the special merchant number and the AppID (that is, it is configured as sub_appid, which can be passed in when initiating payment)',
	sales_scenes_store_indoor_app_tip_4: '(1) If the APPID subject is the same as the merchant subject, the binding is completed directly;',
	sales_scenes_store_indoor_app_tip_5:
		'(2) If the main body of APPID is inconsistent with the main body of the merchant, the merchant will display the "Joint Operation Commitment Letter" when signing the contract, and the administrator of the AppID needs to log in',
	sales_scenes_store_indoor_app_tip_6: ' Public platform ',
	sales_scenes_store_indoor_app_tip_7: 'Confirm the willingness to bind; (AppIDs that bind different subjects are not supported for now)',
	sales_scenes_mp_app_id: 'Service provider official account AppID',
	sales_scenes_mp_app_id_tip_1: 'Service provider official account AppID',
	sales_scenes_mp_sub_app_id: 'Merchant Official Account AppID',
	sales_scenes_mp_sub_app_id_tip_1:
		'1. Please fill in the certified public account APPID, which must be a certified service account, government or media subscription account;',
	sales_scenes_mp_sub_app_id_tip_2:
		'2. After completing the entry, the system initiates the binding of the special merchant number and the AppID (that is, it is configured as sub_appid, which can be passed in when initiating payment)',
	sales_scenes_mp_sub_app_id_tip_3: '(1) If the APPID subject is the same as the merchant subject, the binding is completed directly;',
	sales_scenes_mp_sub_app_id_tip_4:
		'(2) If the main body of APPID is inconsistent with the main body of the merchant, the merchant will display the "Joint Operation Commitment Letter" when signing the contract, and the administrator of the AppID needs to log in',
	sales_scenes_mp_sub_app_id_tip_5: ' Public platform ',
	sales_scenes_mp_sub_app_id_tip_6: 'Confirm the willingness to bind;',
	sales_scenes_mp_pic: 'Screenshot of the official account page',
	sales_scenes_mp_pic_tip_1:
		'Please provide page screenshots/design drafts (up to 5) showing the goods/services. If the official account is not well established or online, please provide it.',
	sales_scenes_mini_program_app_id: 'Service provider applet AppID',
	sales_scenes_mini_program_app_id_tip_1: 'Please fill in the certified applet APPID.',
	sales_scenes_mini_program_sub_app_id: 'Merchant applet AppID',
	sales_scenes_mini_program_sub_app_id_tip_1: '1. Please fill in the certified applet APPID.',
	sales_scenes_mini_program_sub_app_id_tip_2:
		'2. After completing the entry, the system initiates the binding of the special merchant number and the AppID (that is, it is configured as sub_appid, which can be passed in when initiating payment)',
	sales_scenes_mini_program_sub_app_id_tip_3: '(1) If the APPID subject is the same as the merchant subject, the binding is completed directly;',
	sales_scenes_mini_program_sub_app_id_tip_4:
		'(2) If the main body of APPID is inconsistent with the main body of the merchant, the merchant will display the "Joint Operation Commitment Letter" when signing the contract, and the administrator of the AppID needs to log in',
	sales_scenes_mini_program_sub_app_id_tip_5: ' Public platform ',
	sales_scenes_mini_program_sub_app_id_tip_6: 'Confirm the willingness to bind;',
	sales_scenes_mini_program_pic: 'Screenshot of the applet',
	sales_scenes_mini_program_pic_tip_1:
		'Please provide screenshots/design drafts (up to 5) of the page displaying the goods/services. If the Mini Program is not well established or is not online, please provide it.',
	sales_scenes_app_app_id: 'Service Provider AppID',
	sales_scenes_app_app_id_tip_1: "You can fill in the AppID of the current service provider's merchant account that has been bound;",
	sales_scenes_app_sub_app_id: 'Merchant AppID',
	sales_scenes_app_sub_app_id_tip_1:
		'Please fill in the app ID that is consistent with the business entity and has been certified; it is not supported to bind the APPID of different entities',
	sales_scenes_app_sub_app_id_tip_2:
		'After the review is passed, the system will initiate the binding of the merchant number of the special merchant with the AppID (that is, configure it as sub_appid). The service provider can then choose to pass in the appid when initiating payment to complete the payment, and obtain the sub_openid for data statistics. Marketing and other business scenarios.',
	sales_scenes_app_sub_app_id_pic: 'App screenshot',
	sales_scenes_app_sub_app_id_pic_tip_1:
		'Please provide 1 screenshot of APP home page, last page screenshot, in-app screenshot and payment page screenshot',
	sales_scenes_app_sub_app_id_pic_tip_2: 'View example',
	settlement_info: 'Settlement Information',
	label_industry: 'Industry',
	label_industry_tip: 'If there is no data, please select the group subject first',
	settlement_rule_intro: 'Description of settlement rules corresponding to the selected industry',

	subject_special_category_name: 'Applicable subject special identity',
	income_limit_desc: 'Receipt limit',
	credit_limit_desc: 'Description of applicable credit card restrictions',
	settlement_funds_flow_desc: 'Description of applicable funds flow',
	special_qualification_desc: 'Special qualification requirements',
	special_qualification_doc: 'Special qualification documents',
	special_qualification_doc_tip_1: 'Requirements for uploading qualification documents:',
	special_qualification_doc_tip_2: '1. Qualification documents should be pictures',
	special_qualification_doc_tip_3:
		'2. The qualification file should not exceed 5 pictures, and the format requirements are: png, jpg, bmp, and each picture should be less than 2M',
	super_admin_info: 'Super Admin Information',
	super_admin_type: 'Super admin type',
	super_admin_name: 'Super admin name',
	super_admin_phone: 'Mobile phone',
	super_admin_email: 'Email Address',
	super_admin_cert_type: 'Certificate type',
	super_admin_cert_number: 'Certificate number',
	super_admin_open_id: 'Wechat openId',
	super_admin_doc_copy: 'Certificate front photo',
	super_admin_doc_copy_back: 'Reverse photo of the certificate',
	super_admin_doc_copy_btn: 'Upload front',
	super_admin_doc_copy_back_btn: 'Upload reverse',
	super_admin_authorization_letter: 'Business authorization letter',
	super_admin_cert_date: 'Certificate date',
	sale_scenes_web_domain: 'Internet website domain name',
	sale_scenes_web_domain_tip_1:
		'For scenarios such as PC-side malls, smart terminals, etc., you can upload the official website link (the format must start with http:// or https://); e.g. https://www.wechat.com',
	sale_scenes_web_domain_tip_2:
		'The website domain name requires ICP filing. If the filing subject is different from the application subject, please upload the official seal.',
	sale_scenes_web_authorisation: 'Website authorization letter',
	sale_scenes_web_authorisation_tip_1:
		'If the filing subject is different from the application subject, please be sure to upload the website authorization letter with the official seal',
	sale_scenes_web_appid: 'Website merchant AppID ',
	sale_scenes_wework_subcorpid: 'Merchant enterprise wechat corpId',
	sale_scenes_wework_pics: 'Screenshot of enterprise WeChat page',

	sales_scenes_web_tip_1:
		'1. You can fill in the APPID of the certified official account, applet, and application, of which the official account APPID must be a certified service account, government or media subscription account.',
	sales_scenes_web_tip_2: ' AppID Viewing Guidelines',
	sales_scenes_web_tip_3:
		'2. After completing the entry, the system initiates the binding of the special merchant number and the AppID (that is, it is configured as sub_appid, which can be passed in when initiating payment)',
	sales_scenes_web_tip_4: '(1) If the APPID subject is the same as the merchant subject, the binding is completed directly;',
	sales_scenes_web_tip_5:
		'(2) If the main body of APPID is inconsistent with the main body of the merchant, the merchant will display the "Joint Operation Commitment Letter" when signing the contract, and the administrator of the AppID needs to log in',
	sales_scenes_web_tip_6: ' Public platform ',
	sales_scenes_web_tip_7: 'Confirm the willingness to bind; (AppIDs that bind different subjects are not supported for now)',
	sale_scenes_wework_subcorpid_tip_1:
		"You can fill in the certified corporate WeChat CorpID that is consistent with the main body of the merchant; after the approval, the system will open the merchant's own transaction authority in the corporate WeChat area, and complete the binding of the merchant's merchant ID to the CorpID;",
	sale_scenes_wework_subcorpid_tip_2: 'CorpID View Guidelines',
	sale_scenes_wework_pics_tip_1: 'Please provide screenshots/design drafts of the page displaying the goods/services (up to 5) ',
	sale_scenes_wework_pics_tip_2: 'View example',
	cert_query: 'Certificate key query',
	cert_query_result: 'Certificate key query result',
	change_admin_info: 'Super administrator change information',
	payment_base_info: 'Basic payment information',
	payment_type: 'Payment verification category',
	bill_of_lading_type: 'Bill of lading type',
	merchant_apply_no: 'Merchant apply no.',
	withdrawal_account: 'Withdrawal account',
	withdrawal_card_number: 'Withdrawal card number',
	screenshot_of_payment_verification_notification: 'Payment verification notification pic',
	receiving_account_information: 'Receiving account information',
	remittance_instructions: 'Remittance Instructions',
	remittance_amount: 'Remittance Amount (Yuan)',
	payee_account_name: 'Payee account name',
	receipt_card_number: 'Card number',
	receipt_card_number_first_15_digits: 'Card number (first 15 digits)',
	receipt_card_number_last_10_digits: 'Card number (last 10 digits)',
	receipt_card_number_last_10_digits_confirmed: 'Card number (last 10 digits confirmed)',
	can_not_be_copied_only_manual_entry: 'can not be copied, only manual entry',
	please_enter_the_card_number_manually: 'Please enter the card number manually',
	please_enter_the_merchant_s_opening_application_number: 'Please enter the merchant apply number to bring out the payment account',
	please_enter_the_merchant_s_opening_application_number_admin: 'Please enter the merchant number to bring out the payment account',
	please_enter_the_merchant_s_opening_payee_account_name: 'Please enter the merchant apply number to bring out the payee account name',
	please_enter_the_merchant_s_opening_payee_account_name_admin: 'Please enter the merchant number to bring out the payee account name',
	please_enter_the_merchant_s_opening_withdrawal_card_number: 'Please enter the merchant apply number to bring out the withdrawal card number',
	please_enter_the_merchant_s_opening_withdrawal_card_number_admin: 'Please enter the merchant number to bring out withdrawal card number',
	please_enter_the_first_15: 'Please enter the merchant apply number and bring out the payment card number (the first 15 digits)',
	please_enter_the_first_15_admin: 'Please enter the merchant number and bring out the payment card number (the first 15 digits)',
	card_num_inconsistent: 'The payment card number (last 10 digits) entered twice are inconsistent',
	super_administrator_information_has_not_changed: 'Super administrator information has not changed!',
	submit_application_successfully: 'Submit application successfully',
	payment_order_number: 'payment order number',
	payment_progress: 'Payment progress',
	payment_verification_result: 'Payment verification result',
	legal_person: 'Legal person',
	owner_person: 'Owner',
	our_main_body: 'Our subject',
	my_merchant_list: 'My Merchant List',
	result_query_code: 'Result query code',
	pre_admin: 'Admin Before Change',
	next_admin: 'Admin After Change',
	apply_time: 'Apply time',
	error_info: 'Error info',
	merchant_info: 'Merchant Infomation',
	merchant_bank_info: 'Merchant offline top-up bank account information',
	receive_payment_bank_number: 'Bank number',
	receive_payment_bank_account_name: 'Bank account name',
	receive_payment_bank_account_number: 'Bank account number',
	merchant_bank_info_tip:
		'Note: You need to open the transfer recharge function on the WeChat payment merchant account platform first, and only support WeChat merchant accounts',
	payment_apply_time: 'Payment apply time',
	resubmit_new: 'Resubmit new',
	supplementary_merchant_number: 'Supplementary merchant number',
	maintain_receiving_account_information: 'Maintain receiving account information',
	resubmit_existing_application_form: 'Resubmit existing application form',
	scan_to_check_at_the_payment_institution: 'Scan to check at the payment institution',
	biz_line: 'Business line'
};
